<template>
    <div >
    </div>
</template>

<script>



export default {
  name: 'AllGamesPar',
  data(){
      return{
        
      }
  },


}

</script>

<style scoped>

</style>
